
























































































import { cloneDeep, isEqual } from 'lodash';
import {
  EAiStreamerConnectionModeStatus,
  TCopyStakeGlobalAiStreamerConfigurationPayload,
  TCopyStakeGlobalAiStreamerConfigurationResponse,
  ValidationRule
} from '@/api/schema';
import { required } from '@/helpers/validation';
import {
  getGlobalAiStreamerConfig,
  updateGlobalAiStreamerConfig
} from '@/api/CopyStake/AiStreamer';
import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';

const defaultConfig = (): TCopyStakeGlobalAiStreamerConfigurationPayload => ({
  imageVersion: '',
  elevenlabsEnabled: false,
  connectionMode: EAiStreamerConnectionModeStatus.INCLUSTER
});

export default {
  name: 'SuperAdminConfigurationCopyStakeAiStreamer',
  data(): any {
    return {
      EAiStreamerConnectionModeStatus,

      configSavedData: defaultConfig(),
      config: defaultConfig(),

      isLoading: false,
      formValid: false,

      metadata: {
        updatedAt: null,
        updatedBy: null
      }
    };
  },
  computed: {
    configChanged(): boolean {
      return !isEqual(this.config, this.configSavedData);
    },
    valueCanBeSaved(): boolean {
      return this.formValid && this.configChanged;
    },

    imageVersionRules(): ValidationRule[] {
      return [(v) => required(v, 'Image Version')];
    }
  },
  created(): void {
    this.getConfiguration();
  },
  methods: {
    parseConfigData(
      data: TCopyStakeGlobalAiStreamerConfigurationResponse
    ): void {
      const parsedConfig: TCopyStakeGlobalAiStreamerConfigurationPayload = {
        imageVersion: data.imageVersion || '',
        elevenlabsEnabled: data.elevenlabsEnabled ?? false,
        connectionMode:
          data.connectionMode || EAiStreamerConnectionModeStatus.INCLUSTER
      };

      const parsedMetadata = {
        updatedAt: data.updatedAt || null,
        updatedBy: data.updatedBy || null
      };

      this.configSavedData = cloneDeep(parsedConfig);
      this.config = cloneDeep(parsedConfig);
      this.metadata = cloneDeep(parsedMetadata);
    },

    async getConfiguration(): Promise<void> {
      this.isLoading = true;

      getGlobalAiStreamerConfig()
        .then((data: TCopyStakeGlobalAiStreamerConfigurationResponse) => {
          this.parseConfigData(data);
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async updateConfiguration(): Promise<void> {
      const isFormValid = await (this.$refs.form as any).validate();
      if (!isFormValid) return;

      this.isLoading = true;

      const payload: TCopyStakeGlobalAiStreamerConfigurationPayload =
        this.config;

      await updateGlobalAiStreamerConfig(payload)
        .then((data: TCopyStakeGlobalAiStreamerConfigurationResponse) => {
          this.parseConfigData(data);

          this.$toast.success(
            'AI Streamer Global configuration was successfully updated!'
          );
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
